<div [class]="specialBlock.uId"
     class="pagination-container"
     app-block-container
     [disableTabIndex]="false"
     [children]="specialBlock.children"></div>

